
import {GeoCircle, GeoPoint, GeoPolygon, TerminalLocationArea} from "./models";

export const MaxSquareMetersAllowed = 100_000_000; // Areas larger than this will not be allowed added

export interface Area {
    mapRemove();
    toString(): string;
    squareMeters(): number;
    markerPos(): google.maps.LatLng;
    label: string;
    id: number;
    toTerminalLocationArea(terminalLocationId: number): TerminalLocationArea;

}

export class Circle implements Area{
    private pGeoCircle: GeoCircle;
    private pOverlayref: google.maps.Circle;
    private pLabel: string = "";
    public id: number = 0;  // Set for entities loaded from server

    constructor(overlayref: google.maps.Circle) {
        this.pOverlayref = overlayref;
        const center = new GeoPoint(overlayref.getCenter().lat(), overlayref.getCenter().lng());
        this.pGeoCircle = new GeoCircle(center, overlayref.getRadius());
    }

    get geoCircle() {
        return this.pGeoCircle;
    }
    get overlayref() {
        return this.pOverlayref;
    }

    mapRemove() {
        this.overlayref.setMap(null);
    }

    toString() {
        return `Sirkel, ${Math.round(this.geoCircle.radius)} meter radius`
    }
    squareMeters() {
        return Math.PI * Math.pow(this.geoCircle.radius, 2);
    }
    markerPos() {
        return this.overlayref.getCenter();
    }
    set label(txt: string) {
        this.pLabel = txt;
    }
    get label() {
        return this.pLabel;
    }
    toTerminalLocationArea(terminalLocationId: number): TerminalLocationArea {
        return new TerminalLocationArea(this.id, terminalLocationId, this.geoCircle);
    }
}

export class Polygon implements Area {
    private pGeoPolygon: GeoPolygon;
    private pOverlayref: google.maps.Polygon;
    private pLabel: string = "";
    public id: number = 0; // Set for entites loaded from server

    constructor(overlayref: google.maps.Polygon) {
        this.pOverlayref = overlayref;
        let points: GeoPoint[] = [];
        overlayref.getPath().forEach((p, i) => {
            points.push(new GeoPoint(p.lat(), p.lng()));
        });
        this.pGeoPolygon = new GeoPolygon(points);
    }

    get geoPolygon() {
        return this.pGeoPolygon;
    }
    get overlayref() {
        return this.pOverlayref;
    }
    mapRemove() {
        this.overlayref.setMap(null);
    }
    toString() {
        return `Område, ${Math.round(this.squareMeters())}m2`;
    }
    squareMeters() {
        return google.maps.geometry.spherical.computeArea(this.overlayref.getPath());
    }
    markerPos() {
        const bounds = new google.maps.LatLngBounds();
        this.overlayref.getPath().forEach((point) => {
            bounds.extend(point);
        });
        return bounds.getCenter();
    }
    set label(txt: string) {
        this.pLabel = txt;
    }
    get label() {
        return this.pLabel;
    }
    toTerminalLocationArea(terminalLocationId: number): TerminalLocationArea {
        return new TerminalLocationArea(this.id, terminalLocationId, this.geoPolygon);
    }
}

// similar to OverlayTypes in @types/googlemaps/index.d.ts
export enum Drawingmethod {
    /**
     * Specifies that the DrawingManager creates circles, and that the overlay
     * given in the overlaycomplete event is a circle.
     */
    CIRCLE = 1,
    /**
     * Specifies that the DrawingManager creates polygons, and that the
     * overlay given in the overlaycomplete event is a polygon.
     */
    POLYGON,
}
